import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "image-links-dialog",
  templateUrl: "./image-links-dialog.component.html",
  styleUrls: ["./image-links-dialog.component.scss"]
})
export class ImageLinksDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImageLinksDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { images: string[] }
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  getTruncatedUrl(url: string): string {
    const maxLength = 60;
    if (url.length <= maxLength) {
      return url;
    }
    const start = url.substring(0, 30);
    const end = url.substring(url.length - 27);
    return `${start}...${end}`;
  }

  downloadImage(url: string, index: number): void {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.download = `product-image-${index + 1}`;
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
